import { createFileRoute } from '@tanstack/react-router';
import { useParams } from '@tanstack/react-router';
import { Loader } from '@/components/Loading';
import { Text } from '@/components/Typography';
import { Dialog } from '@/components/ui/dialog';
import { ApprovalTaskDetailDialogContent } from '@/features/boe-task/components/ApprovalTaskDetail/ApprovalTaskDetailDialogContent';
import { useTranslation } from '@/lib/i18n';
import { useDetailDialog } from '../../-hooks/useDetailDialog';
import { useApprovalActions } from './-hooks/useApprovalActions';
import { useApprovalTaskDetailQuery } from './-query/useApprovalTaskDetailQuery';
import { mapApprovalFlowToApprovers } from './-utils/approvalFlowMapper';
export const Route = createFileRoute('/_staff/cockpit/approval/$id/')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    id
  } = useParams({
    from: '/_staff/cockpit/approval/$id/'
  });
  const {
    data,
    isLoading,
    error
  } = useApprovalTaskDetailQuery(id);
  const {
    approve,
    sendBack,
    isSendingBack
  } = useApprovalActions();
  const {
    open,
    setOpen
  } = useDetailDialog();
  const {
    t
  } = useTranslation('translation', {
    keyPrefix: 'pages.cockpit.detail'
  });

  // ローディング中
  if (isLoading) {
    return <div className="flex h-screen w-full items-center justify-center">
        <Loader />
      </div>;
  }

  // エラー
  if (error || !data) {
    return <div className="flex h-screen w-full items-center justify-center">
        <Text variant="p" className="text-red-600">
          {t('error')}
        </Text>
      </div>;
  }

  // 現在のステージを計算（PendingApprovalのステップを探す）
  const currentStep = data.approvalFlow.find(step => step.status === 'PendingApproval');

  // 承認 / 差し戻しの対象となる提出版。BE は「承認者が見ていた版」と最新版の一致を
  // 要求するため（楽観ロック）、取れないとき（未提出）は操作させない。
  // 「最新」の判定は BE 側（イベントストアの version 順）に委ねる。submissions の並びや
  // submittedAt からは再計算できない（同一リクエスト内の操作は時刻が同値になる）
  const expectedSubmissionEventId = data.approvalReturnInfo?.latestSubmissionEventId ?? undefined;
  return <>
      <Dialog open={open} onOpenChange={setOpen}>
        <ApprovalTaskDetailDialogContent taskStatus="InProgress" taskType="Approval" taskName={data.approvalTaskName} taskTarget={data.target?.name} targetSubordinate={data.target?.description} description={data.approvalTaskCatalogDescription} progress={currentStep ? {
        current: currentStep.order,
        total: data.approvalFlow.length
      } : undefined} approvers={mapApprovalFlowToApprovers(data.approvalFlow)} submitTaskForm={data.submitTaskForm}
      // 過去に差し戻していれば申請書の上に履歴を出す（スタッフが経緯を追えるようにする）
      returnInfo={data.approvalReturnInfo} onApprove={expectedSubmissionEventId ? async () => {
        await approve(id, expectedSubmissionEventId);
        setOpen(false);
      } : undefined}
      // 差し戻せる状態のときだけハンドラを渡す（渡さなければボタンは出ない）。
      // 可否判定は BE の canSendBack が正（設定 + 承認待ち + 差し戻し経路の AND）
      onReturn={data.approvalReturnInfo?.canSendBack && expectedSubmissionEventId ? async (reason?: string) => {
        await sendBack(id, expectedSubmissionEventId, reason);
        setOpen(false);
      } : undefined} isSendingBack={isSendingBack} />
      </Dialog>
    </>;
}